module.exports = __webpack_public_path__ + "static/media/avatarPam.fb8a048a.jpg";